// Package Imports
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';

// Models
import { AuthMetaData } from '../../models';

// Services
import { SessionService } from '../../services/session/session.service';

@Component({
  selector: 'app-sso-landing',
  templateUrl: './sso-landing.component.html',
  styleUrls: ['./sso-landing.component.css']
})
export class SsoLandingComponent implements OnInit {
  constructor(private activatedRoute: ActivatedRoute,
              private readonly router: Router,
              private readonly sessionService: SessionService) { }

  ngOnInit() {
    const data = new AuthMetaData();

    data.partner = this.activatedRoute.snapshot.queryParams.partner;
    data.entityIdForAdminView = this.activatedRoute.snapshot.queryParams.entityId;
    this.sessionService.storeSessionData(this.sessionService.sessionKey_AuthMetaData, data);
    this.router.navigate(['/ssologin']);
  }
}
